
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/filosofia",
      function () {
        return require("private-next-pages/filosofia.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/filosofia"])
      });
    }
  